import React from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  useTheme,
} from '@mui/material';

interface EmailFormatSelectorProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  title?: string;
  subtitle?: string;
}

export const EmailFormatSelector: React.FC<EmailFormatSelectorProps> = ({
  value,
  onChange,
  name = 'contentType',
  title = 'Email Format Preference',
  subtitle,
}) => {
  const theme = useTheme();

  return (
    <Box>
      <FormControl fullWidth>
        <FormLabel
          component="legend"
          sx={{
            textAlign: 'left',
            fontWeight: 'bold',
            color: theme.palette.text.primary,
          }}
        >
          {title}
        </FormLabel>
        {subtitle && (
          <Box sx={{ mb: 2, textAlign: 'left' }}>
            <span
              style={{
                fontSize: '0.875rem',
                color: theme.palette.text.secondary,
              }}
            >
              {subtitle}
            </span>
          </Box>
        )}
        <RadioGroup
          row
          aria-labelledby="email-format-label"
          name={name}
          value={value ?? 'text/html'}
          defaultValue="text/html"
          onChange={onChange}
          sx={{
            justifyContent: 'flex-start',
          }}
        >
          <FormControlLabel
            value="text/plain"
            control={<Radio />}
            label="Plain Text"
          />
          <FormControlLabel
            value="text/html"
            control={<Radio />}
            label="HTML Format"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default EmailFormatSelector;
